export default {
    phone(rule, value, callback) {
        let regFormat = /^[1][3456789][0-9]{9}$/;
        if (!value) {
            return callback(new Error('不能为空'));
        }
        if (!(regFormat.test(value))) {
            callback(new Error('请输入正确手机号'));
        } else {
            callback();
        }
    },
    password(rule, value, callback) {
        let regFormat = /^[1][3456789][0-9]{9}$/;
        if (!value) {
            return callback(new Error('不能为空'));
        }
        if (!(regFormat.test(value))) {
            callback(new Error('密码必须包含xxxx'));
        } else {
            callback();
        }
    },
    email(rule, value, callback) {
        let regFormat = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if (!value) {
            return callback(new Error('不能为空'))
        }
        if (!(regFormat.test(value))) {
            callback(new Error('邮箱格式不正确'));
        } else {
            callback();
        }
    }
}